<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_reset === true">รีเซ็ตรหัสผ่านเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-3">
          <div class="text-right mt-2"
            v-if="$store.state.status == 1 || $store.state.userDetail.manage_partner_create == 1">
            <v-btn height="65" class="white--text grad-success-bg btn_mobile"
              @click="add_partner = true">เพิ่มพาร์ทเนอร์</v-btn>
          </div>
          <v-card-title>
            <v-text-field v-model="search" color="#8cc63e" append-icon="mdi-magnify" label="ค้นหา" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="partnerHeader" :items="all_partner" :footer-props="footer_Props" :search="search"
            mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.customer_code }}</td>
                <td>{{ dataDetail.item.name }}</td>
                <td>{{ dataDetail.item.telephone }}</td>
                <td>
                  <v-switch color="#8cc63e" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)"
                    v-model="dataDetail.item.status" :disabled="disabled_status"></v-switch>
                </td>
                <td class="pa-3">
                  <v-btn small height="42" @click="getDetails(dataDetail.item.id)"
                    class="grad-success-bg white--text mr-1 mb-1"
                    v-if="$store.state.status == 1 || $store.state.userDetail.manage_partner_list == 1"
                    title="ดูรายละเอียด">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn small height="42" @click="getEdit(dataDetail.item.id)"
                    class="grad-warning-bg white--text mr-1 mb-1"
                    v-if="$store.state.status == 1 || $store.state.userDetail.manage_partner_edit == 1"
                    title="แก้ไขข้อมูล">
                    <v-icon>mdi-note-edit-outline</v-icon>
                  </v-btn>
                  <v-btn small height="42" @click="delAlert(dataDetail.item.id)" class="grad-danger-bg white--text mb-1"
                    v-if="$store.state.status == 1 || $store.state.userDetail.manage_partner_delete == 1" title="ลบ">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
                <td v-if="$store.state.status === 1">
                  <v-btn small height="42" @click="password_reset(dataDetail.item.id)"
                    class="grad-main-bg white--text mr-1 mb-1" title="รีเซ็ตรหัสผ่าน">
                    รีเซ็ตรหัสผ่าน
                  </v-btn>
                </td>
                <td v-if="dataDetail.item.POS_open == 1">
                  <router-link :to="{ name: 'customerdashboard', params: { customerCode: dataDetail.item.customer_code } }"
                    class="text-success">
                    ดูร้านค้า
                  </router-link>
                </td>

                <td v-else>
                  <v-btn small height="42" @click="open_pos(dataDetail.item.customer_code, dataDetail.item.id)"
                    class="pos-main-bg white--text mr-1 mb-1" title="เปิด POS">
                    เปิด POS
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="add_partner" max-width="900">
          <v-card>
            <v-form ref="add_form" @submit.prevent="createPartner">
              <v-card-title>
                เพิ่มพาร์ทเนอร์
              </v-card-title>

              <v-card-text>
                <div>
                  <div>
                    <div class="d-flex">
                      <v-icon>mdi-account</v-icon>
                      <div class="ml-1">รหัสพาร์ทเนอร์ : {{ partner_add.code }}</div>
                    </div>
                  </div>
                  <div class="grid_half">
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" label="ชื่อสาขา" :autofocus="login_focus"
                        prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อสาขา']"
                        hide-details="auto" v-model="partner_add.name" required outlined></v-text-field>
                    </div>
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" label="เบอร์โทรสำหรับเข้าสู่ระบบ" type="tel" maxlength="11"
                        @keypress="isNumber($event, partner_add.telephone)" prepend-inner-icon="mdi-phone-outline"
                        :rules="phoneRules" hide-details="auto" v-model="partner_add.telephone" required
                        outlined></v-text-field>
                    </div>
                  </div>
                  <div class="mt-3 mr-1">
                    <v-text-field color="#86bc3a" label="อีเมล" type="email" :rules="emailRules" pattern=".@"
                      @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline"
                      hide-details="auto" v-model="partner_add.email" outlined></v-text-field>
                  </div>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  บันทึก
                </v-btn>
                <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px"
                  @click="add_partner = false">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="modal_details" max-width="900">
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="add_form" @submit.prevent="">
                <v-card-title>
                  รายละเอียด
                </v-card-title>

                <v-card-text>
                  <div>
                    <div class="ml-1">รหัสพาร์ทเนอร์ : {{ this.partner_get.code }}</div>
                    <v-card-title class="ml-n4 mb-n2">
                      ข้อมูลส่วนตัว
                    </v-card-title>
                    <div class="grid_half">
                      <div class="mt-3 mr-1">
                        <div class="grid_flex">
                          <div class="d-flex">
                            <div><v-icon>mdi-account-outline</v-icon></div>
                            <div class="ml-1 mt-1">ชื่อสาขา</div>
                          </div>
                          <div class="ml-2 mt-1 grey--text">{{ partner_get.name }}</div>
                        </div>
                      </div>
                      <div class="mt-3 mr-1">
                        <div class="grid_flex">
                          <div class="d-flex">
                            <div><v-icon>mdi-phone-outline</v-icon></div>
                            <div class="ml-1 mt-1">เบอร์โทรศัพท์</div>
                          </div>
                          <div class="ml-2 mt-1 grey--text">{{ partner_get.telephone }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mr-1">
                      <div class="grid_flex">
                        <div class="d-flex">
                          <div><v-icon>mdi-email-outline</v-icon></div>
                          <div class="ml-1 mt-1">อีเมล</div>
                        </div>
                        <div class="ml-2 mt-1 grey--text">{{ partner_get.email }}</div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <div class="text-center pa-4">
                  <v-btn large class="grad-danger-bg white--text btn_mobile" type="button" style="font-size: 18px"
                    @click="modal_details = false">
                    ปิด
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
        <v-dialog v-model="modal_edit" max-width="900">
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="update_form" @submit.prevent="updatePartner">
                <v-card-title>
                  แก้ไขพาร์ทเนอร์
                </v-card-title>

                <v-card-text>
                  <div>
                    <div>
                      <div class="d-flex">
                        <v-icon>mdi-account</v-icon>
                        <div class="ml-1">รหัสพาร์ทเนอร์ : {{ this.partner_get.code }}</div>
                      </div>
                    </div>
                    <div class="grid_half">
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" label="ชื่อสาขา" prepend-inner-icon="mdi-account-outline"
                          :rules="[v => !!v || 'กรุณากรอกชื่อสาขา']" hide-details="auto" v-model="partner_get.name"
                          required outlined></v-text-field>
                      </div>
                      <div class="mt-3 mr-1">
                        <v-text-field color="#86bc3a" label="เบอร์โทรสำหรับเข้าสู่ระบบ" type="tel" maxlength="11"
                          @keypress="isNumber($event, partner_get.telephone)" prepend-inner-icon="mdi-phone-outline"
                          :rules="phoneRules" hide-details="auto" v-model="partner_get.telephone" required
                          outlined></v-text-field>
                      </div>
                    </div>
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" label="อีเมล" :rules="emailRules" type="email"
                        @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline"
                        hide-details="auto" v-model="partner_get.email" outlined></v-text-field>
                    </div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <div class="text-center pa-4">
                  <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                    แก้ไข
                  </v-btn>
                  <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px"
                    @click="modal_edit = false">
                    ยกเลิก
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
      </v-card>
      <!-- ลบร้าน -->
      <v-dialog v-model="cancel_bill" persistent max-width="580">
        <v-form ref="cancelBill" @submit.prevent="getDelete()">
          <v-card class="input-radius">
            <div class="d-flex justify-space-between">
              <v-card-title>
                <b>ลบร้านค้า</b>
              </v-card-title>
              <v-btn icon class="ma-4" @click="cancel_bill = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <label>รหัสผ่าน <span class="required--text">*</span></label>
                  <v-text-field label="รหัสผ่าน" prepend-inner-icon="mdi-lock" v-model="cancel.password" color="#D6BFAF"
                    hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                    @click:append="show = !show" single-line outlined dense required></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn type="submit" color="#EC6061" elevation="4" large>ลบร้านค้า</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { HTTP } from '@/axios.js'
import { HTTP_ARIN } from '@/axios_arin.js'
import { isTelephone, onPaste, validateEmail } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "PartnerList",
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      add_partner: false,
      search: null,
      modal_details: false,
      modal_edit: false,
      modal_delete: false,
      alert_success: false,
      alert_reset: false,
      disabled_status: false,
      login_focus: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      phoneRules: [v => (v.length > 8) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      partner_morg: {
        id: null,
        name: 'บจ. ซิลลิค ฟาร์มา',
        telephone: '0854852359',
        email: 'phama_plus@gmail.com',
      },
      partner_add: {
        id: null,
        code: null,
        name: null,
        telephone: '',
        email: '',
      },
      partner_get: {
        id: null,
        code: null,
        name: null,
        telephone: '',
        email: '',
      },
      partnerHeader: [],
      all_partner: [],
      cancel_bill: false,
      cancel: {
        part_id: null,
        password: null,
      }
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    async page() {
      if (this.$store.state.status === 1) {
        this.partnerHeader = [
          {
            text: 'รหัสสาขา',
            value: 'customer_code',
            fixed: true,
            width: '125px',
          },
          {
            text: 'ชื่อสาขา',
            value: 'name',
            fixed: true,
            width: '450px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '90px',
          },
          {
            text: 'เมนูจัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'รีเซ็ตรหัสผ่าน',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'POS',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
        this.getCustomer()
      }
      else {
        this.partnerHeader = [
          {
            text: 'รหัสสาขา',
            value: 'customer_code',
            fixed: true,
            width: '125px',
          },
          {
            text: 'ชื่อสาขา',
            value: 'name',
            fixed: true,
            width: '450px',
          },
          {
            text: 'เบอร์โทร',
            value: 'telephone',
            fixed: true,
            width: '125px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '90px',
          },
          {
            text: 'เมนูจัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
        ]
        this.getCustomer()
      }
    },
    checkLoading() {
      this.loading_page = true
      HTTP.post('/customers/customerlist', {
        customer_type: 3
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.all_partner = res.data.object
        }
      })
    },
    delAlert(id) {
      this.cancel.part_id = id
      this.cancel_bill = true;

    },
    editAlert() {
      Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success')
        .then(() => {
          this.getCustomer();
        })
    },
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
        .then(() => {
          this.genId_code();
          this.getCustomer();
        });
    },
    createPartner() {
      if (this.partner_add.name !== null && this.partner_add.telephone !== null && this.partner_add.name !== '' && this.partner_add.telephone !== '') {
        HTTP.post('/customers/create', {
          customer_type: 3,
          customer_status: 1,
          clinics: 0,
          customer_code: this.partner_add.code,
          name: this.partner_add.name,
          telephone: this.partner_add.telephone,
          email: this.partner_add.email,
          status: 1,
        }).then((res) => {
          if (res.data.success === true) {
            this.partner_add.code = null;
            this.partner_add.name = null;
            this.partner_add.telephone = '';
            this.partner_add.email = '';
            this.add_partner = false;
            this.createAlert();
            this.open_pos(res.data.object.customer_code, res.data.object.id);
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถบันทึกได้ !',
              text: res.data.message,
              icon: 'error',
              confirmButtonText: 'ตกลง'
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถบันทึกได้ !',
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        }).then(() => {
          this.$refs.add_form.validate()
        })
      }
    },
    getCustomer() {
      HTTP.post('/customers/customerlist', {
        customer_type: 3
      }).then((res) => {
        if (res.data.success === true) {
          this.all_partner = res.data.object
        }
      })
    },
    getDetails(id) {
      this.modal_details = true
      this.loading_modal = true
      HTTP.post('/customers/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.partner_get.id = res.data.object.id;
          this.partner_get.code = res.data.object.customer_code;
          this.partner_get.name = res.data.object.name;
          this.partner_get.telephone = res.data.object.telephone;
          this.partner_get.email = res.data.object.email;
        }
      })
    },
    getEdit(id) {
      this.modal_edit = true
      this.loading_modal = true
      HTTP.post('/customers/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.partner_get.id = res.data.object.id;
          this.partner_get.code = res.data.object.customer_code;
          this.partner_get.name = res.data.object.name;
          this.partner_get.telephone = res.data.object.telephone;
          this.partner_get.email = res.data.object.email;
        }
      })
    },
    updatePartner() {
      if (this.partner_get.name !== null && this.partner_get.telephone !== null && this.partner_get.name !== '' && this.partner_get.telephone !== '') {
        HTTP.post('/customers/edit', {
          id: this.partner_get.id,
          clinics: 0,
          name: this.partner_get.name,
          telephone: this.partner_get.telephone,
          email: this.partner_get.email
        }).then((res) => {
          if (res.data.success === true) {
            this.partner_get.id = null;
            this.partner_get.name = null;
            this.partner_get.telephone = '';
            this.partner_get.email = '';
            this.modal_edit = false;
            this.editAlert();
          }
          if (res.data.success === false) {
            Swal.fire({
              title: 'ไม่สามารถบันทึกได้ !',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถบันทึกได้ !',
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.update_form.validate()
        })
      }
    },
    password_reset(id) {
      Swal.fire({
        title: 'คุณต้องการรีเซ็ตรหัสผ่านหรือไม่ ?',
        text: 'รหัสผ่านจะถูก รีเซ็ตเป็นค่าเริ่มต้น !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/customers/reset', {
            customer_id: id,
          }).then((result) => {
            if (result.data.success === true) {
              this.alert_reset = true
              setTimeout(() => this.alert_reset = false, 2000)
            }
          })
        }
      })
    },
    genId_code() {
      HTTP.post('/customers/getcusid/partner')
        .then((response) => {
          if (response.data.success === true) {
            this.partner_add.code = response.data.object;
          }
        })
    },
    async getDelete() {

      await HTTP.post('/customers/check/password', {
        id: this.$store.state.userDetail.id,
        password: this.cancel.password
      }).then(async (result) => {
        if (result.data.success === true) {
          await HTTP.post('/customers/delete', {
            id: this.cancel.part_id,
          }).then(async (res) => {
            if (res.data.success === true) {
              await HTTP_ARIN.get('/stores/delete/' + this.cancel.part_id).then((response) => {
                if (response.data.successful === true) {
                  Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
                  this.cancel_bill = false,
                    this.cancel = {
                      part_id: null,
                      password: null,
                    }
                  this.getCustomer();
                }
              });
            }
          });
        }
      }).catch(err => {
        if (err.response.status == 401) {
          Swal.fire('รหัสผ่านไม่ถูกต้อง', '', 'warning');
        }
      })
    },
    changeStatus(id, status) {
      if (status == false) {
        status = 0
      }
      else if (status == true) {
        status = 1
      }
      this.disabled_status = true
      HTTP.post('/customers/updatestatus', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.disabled_status = false
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 1000);
        }
      })
    },
    open_pos(customer_code, id) {
      // Swal.fire({
      //   title: 'เปิดระบบ POS',
      //   text: 'คุณต้องการเปิดระบบ POS ร้านนี้หรือไม่ ?',
      //   icon: 'warning',
      //   showDenyButton: true,
      //   showCancelButton: false,
      //   confirmButtonText: `ตกลง`,
      //   denyButtonText: `ยกเลิก`,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      HTTP_ARIN.post('/stores/create/' + customer_code, null).then((res) => {
        if (res.data.successful === true) {
          HTTP.get('/update/status/open/post/' + id).then((response) => {
            if (response.data.success === true) {
              this.checkLoading()
            }
          })
        }
      })
      // }
      // })
    },
    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit('logout_success');
        this.$router.push('/login');
      }
      else if (this.$store.state.userDetail.manage_partner_list == 0 && this.$store.state.userDetail.manage_partner_create == 0 && this.$store.state.userDetail.manage_partner_edit == 0 && this.$store.state.userDetail.manage_partner_delete == 0) {
        this.$router.push('/retailer');
      }
    },
  },
  beforeMount() {
    this.checkLogIn()
    this.checkLoading()

  },
  mounted() {
    this.genId_code()
    this.page()
  }
}
</script>

<style scoped>
.pos-main-bg {
  background-color: #957E5D !important;
  color: #FFF;
}

.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
  }
}
</style>
